<template>
  <div>
    <v-teleport to="header">
      <div class="flex mb-20">
        <el-button-group>
          <el-button
            :type="onlyArchived ? 'default' : 'primary'"
            size="medium"
            round
            @click="onlyArchived = false">
            {{ $tc('general.active') }}
          </el-button>
          <el-button
            :type="onlyArchived ? 'primary' : 'default'"
            icon="el-icon-takeaway-box"
            size="medium"
            round
            @click="onlyArchived = true">
            {{ $tc('general.archive') }}
          </el-button>
        </el-button-group>
      </div>
    </v-teleport>

    <panel :title="$tc('menu.users')">
      <UsersTable :data="filteredUsers" can-edit />
    </panel>
  </div>
</template>

<script>
import UsersTable from '@/components/users/UsersTable.vue'

export default {
  components: {
    UsersTable
  },

  data () {
    return {
      onlyArchived: false
    }
  },

  computed: {
    users () {
      return this.$store.getters['users/list'] || []
    },

    filteredUsers () {
      return this.users.filter(user => {
        return this.onlyArchived ? user.isBlocked : !user.isBlocked
      })
    }
  },

  created () {
    this.$store.commit('app/set', {
      title: this.$tc('menu.users'),
      breadcrumbs: [
        {
          text: this.$tc('menu.users')
        }
      ]
    })

    this.load()
  },

  methods: {
    async load () {
      this.loading = true
      try {
        await this.$store.dispatch('users/load')
        this.error = false
      } catch (e) {
        console.error(e)
        this.error = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
